/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForKubernetesCluster extends models.GovernanceConfigurationBaseForResource {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForKubernetesCluster");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForKubernetesCluster.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForKubernetesCluster>): GovernanceConfigurationForKubernetesCluster {
        let obj = Object.assign(new GovernanceConfigurationForKubernetesCluster(), model);
        GovernanceConfigurationForKubernetesCluster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForKubernetesCluster>): GovernanceConfigurationForKubernetesCluster {
        if (!model) return null;
        return GovernanceConfigurationForKubernetesCluster.newInstance(<GovernanceConfigurationForKubernetesCluster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForKubernetesCluster) {
        if (!obj) return;

        models.GovernanceConfigurationForKubernetesCluster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForKubernetesCluster): boolean {
        if (models.GovernanceConfigurationBaseForResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForKubernetesCluster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.full_refresh_day === undefined) {
            this.full_refresh_day = 0;
        }
        if (this.frequency) {
            models.KubernetesClusterFrequency.fixupPrototype(this.frequency);
        }
        if (this.cost_weightage) {
            models.KubernetesCostWeightage.fixupPrototype(this.cost_weightage);
        }
    }

    /**
     * Kubernetes Cluster Frequency configuration.
     */
    frequency: models.KubernetesClusterFrequency;

    /**
     * Kubernetes Cluster Cost weightage configuration.
     */
    cost_weightage: models.KubernetesCostWeightage;

    /**
     * Weekday (1-7) allotted for the cluster full refresh.
     */
    full_refresh_day: number;

}
